export default "__VITE_ASSET__CCG3Df7l__"